export const LIMIT = 12
export const ALL_REWARDS_LIMIT = 50
